var m = require('mithril');
var prop = require('mithril/stream');
var modalForm = require('../layout/components/modalForm');
var modal = require('../layout/components/modal');
var auth = require('../auth/models/session');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var alarmState = require('../alarms/alarmState');
var alerts = require('../layout/components/alerts');
var pointChart = require('./components/pointChart');
var pointEvents = require('./components/pointEvents');
var pointDocuments = require('./components/pointDocuments');
var pointCommands = require('./components/pointCommands');
var Point = require('./models/point');
var resource = require('../network/models/resource');
var tabs = require('../components/tabs');
var headingElement = require('../components/heading');
var overrideMode = modalForm(require('./models/overrideMode'));
var overrideValue = modalForm(require('./models/overrideValue'));
var writeAlternatePoint = modalForm(require('./models/writeAlternatePoint'));
var alarmForm = require('./components/pointAlarmForm');
var statusForm = require('./components/pointStatusForm');
var samplingForm = require('./components/pointSamplingForm');
var bacnetForm = require('./components/pointBacnetForm');
var configForm = require('./components/pointConfigurationForm');
var overrideForm = require('./components/pointOverrideForm');
var calibrationForm = require('./components/pointCalibrationForm');
var connectionsForm = require('./components/pointConnectionsForm');
var pageTitle = require('../layout/pageTitle');
var pointTitlePath = require('./pointTitlePath');
var pointSidebarTab = require('./pointSidebarTab');
var pointHeaderPath = require('./pointHeaderPath');

function hasAlarmEvaluationError(pointRecord) {
  var alarmError = pointRecord && pointRecord.alarmError;
  return alarmError === true || alarmError === 1 || alarmError === '1' || alarmError === 'true';
}

function roleFlagIsEnabled(value) {
  return value === true || value === 1 || value === '1';
}

function currentColumnRid () {
  return m.route.param('column') || null;
}

var oninit = function (vnode) {
  var ctrl = this;

  pageTitle.set(null, { fallback: 'Point Detail' });

  // Retrieved records
  ctrl.point = prop({});
  ctrl.resource = prop({});
  ctrl.originColumn = prop({});
  ctrl.enumerations = prop([]);
  ctrl.overrideModeResource = prop(false);
  ctrl.overrideValueResource = prop(false);
  ctrl.writeAlternatePointResource = prop(false);
  ctrl.alarmProfile = prop(false);
  ctrl.redraw = prop(false);
  // Local state
  ctrl.model = Point;
  ctrl.noData = prop(false);
  ctrl.live = prop(false);
  ctrl.loading = prop(true);
  ctrl.form = {
    start: prop(null),
    span: prop(24),
    resampling: prop('hours')
  };
  ctrl.userIsAdminGroup = prop(false);
  ctrl.pointId = m.route.param('pointId');
  ctrl.columnRid = currentColumnRid();
  if (!ctrl.columnRid || ctrl.columnRid === 'undefined') {
    header.vm.activeTab('Networks');
  }

  ctrl.isCurrentRoute = function (pointId, columnRid) {
    return ctrl.pointId === pointId && ctrl.columnRid === columnRid;
  };

  ctrl.resetPointState = function () {
    ctrl.point({});
    ctrl.resource({});
    ctrl.originColumn({});
    ctrl.overrideModeResource(false);
    ctrl.overrideValueResource(false);
    ctrl.writeAlternatePointResource(false);
    ctrl.alarmProfile(false);
    ctrl.userIsAdminGroup(false);
    ctrl.redraw(false);
    ctrl.loading(true);
    ctrl.getChart = null;
    if (!ctrl.columnRid || ctrl.columnRid === 'undefined') {
      header.vm.activeTab('Networks');
    }
  };
  
  ctrl.initPoint = function () {
    var requestedPointId = ctrl.pointId;
    var requestedColumnRid = ctrl.columnRid;
    var firstPromises = [
      loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/point/' + requestedPointId,
        method: 'GET',
        background: true
      }),
      ctrl.getResource(requestedPointId),
      ctrl.getEnumerations()
    ];

    if (requestedColumnRid && requestedColumnRid !== 'undefined') {
      firstPromises.push(ctrl.getOriginColumn(requestedColumnRid));
    }

    return Promise.all(firstPromises) 
    .then(function (results) {
      if (!ctrl.isCurrentRoute(requestedPointId, requestedColumnRid)) {
        return false;
      }

      const nextRequests = [];
      ctrl.point(results[0]);
      ctrl.resource(results[1] || {});
      // These records are derived from optional edges on the freshly loaded
      // Point. Clear the previous values before resolving any new targets so a
      // deleted edge cannot leave its old configuration rendered indefinitely.
      ctrl.overrideModeResource(false);
      ctrl.overrideValueResource(false);
      ctrl.writeAlternatePointResource(false);
      if (requestedColumnRid && requestedColumnRid !== 'undefined') {
        ctrl.originColumn(results[3]);
      } else {
        ctrl.originColumn({});
      }
      header.vm.activeTab(pointSidebarTab.forOriginColumn(ctrl.originColumn()));
      
      var contextualTitle = pointTitlePath.fromOriginColumn(ctrl.point(), ctrl.originColumn());
      pageTitle.set(contextualTitle ? contextualTitle.record : ctrl.point(), {
        fallback: 'Point Detail',
        path: contextualTitle && contextualTitle.path,
        maxAncestors: 3,
        resource: ctrl.resource()
      });

      resource.initForm.call(resource, ctrl.resource());
      bacnetForm.initForm.call(bacnetForm, ctrl.resource());
      Point.initForm.call(Point, ctrl.point());
      modal.off('closed', ctrl.initPoint);
      modal.once('closed', ctrl.initPoint);
      
      overrideMode.initForm({out: ctrl.point()['@rid']});
      // nextRequests.push(overrideMode.tree.vm.selectRoot());

      overrideValue.initForm({out: ctrl.point()['@rid']});
      // nextRequests.push(overrideValue.tree.vm.selectRoot());

      writeAlternatePoint.initForm(ctrl.point());
      // nextRequests.push(writeAlternatePoint.tree.vm.selectRoot());

      if (ctrl.point().overridemode) {
        nextRequests.push(ctrl.getResource(ctrl.point().overridemode.in.slice(1)).then(function (result) {
          if (ctrl.isCurrentRoute(requestedPointId, requestedColumnRid)) {
            ctrl.overrideModeResource(result);
          }
        }));
      }

      if (ctrl.point().overridevalue) {
        nextRequests.push(ctrl.getResource(ctrl.point().overridevalue.in.slice(1)).then(function (result) {
          if (ctrl.isCurrentRoute(requestedPointId, requestedColumnRid)) {
            ctrl.overrideValueResource(result);
          }
        }));
      }

      if (ctrl.point().writeAlternatePoint) {
        nextRequests.push(ctrl.getResource(ctrl.point().writeAlternatePoint.slice(1)).then(function (result) {
          if (ctrl.isCurrentRoute(requestedPointId, requestedColumnRid)) {
            ctrl.writeAlternatePointResource(result);
          }
        }));
      }

      if (ctrl.point().alarmProfile) {
        nextRequests.push(ctrl.getAlarmProfile(ctrl.point()).then(r=>{
          if (!ctrl.isCurrentRoute(requestedPointId, requestedColumnRid)) {
            return;
          }
          ctrl.alarmProfile(r); 
          ctrl.getChart ? ctrl.getChart({alarmProfile: ctrl.alarmProfile()}) : ''
          ctrl.redraw(false);
        }));
      } else {
        ctrl.alarmProfile(false);
        ctrl.getChart ? ctrl.getChart({alarmProfile: ctrl.alarmProfile()}) : ''
        ctrl.redraw(false);
      }
      nextRequests.push(ctrl.getUsersfromGruops(requestedPointId, requestedColumnRid))

      ctrl.topTabs = {
        Graph: [pointChart, {pointRecord:ctrl.point(), column: ctrl.originColumn()}],
        Incidents: [pointEvents, {pointRecord:ctrl.point(), column: ctrl.originColumn()}]
      }
      if (ctrl.topTabs[m.route.param('tabId')]) {
        ctrl.defaultTab = m.route.param('tabId');
      } else {
        ctrl.defaultTab = 'Graph';
      }

      ctrl.tabLabelRenderer = function (tabName) {
        var enabled = Number(Point.form.alarmEnabled && Point.form.alarmEnabled()) === 1;
        var intervalRaw = typeof resource.form.interval === 'function' ? resource.form.interval() : resource.form.interval;
        var intervalNum = Number(intervalRaw);
        var intervalMissing = !Number.isFinite(intervalNum) || intervalNum <= 0;
        var usesPollGroup = Array.isArray(ctrl.resource().samplingPollGroups) &&
          ctrl.resource().samplingPollGroups.length > 0;
        var needsSamplingWarning = enabled && !usesPollGroup && intervalMissing && tabName === 'Sampling';
        var needsErrorWarning = hasAlarmEvaluationError(ctrl.point()) && tabName === 'Alarms';
        if (!needsSamplingWarning && !needsErrorWarning) return tabName;
        return m('span.flex.items-center.justify-center', [
          m('span', tabName),
          needsSamplingWarning ? m('span.ml2.yellow', {title: 'Sampling rate required'}, '⚠️') : null,
          needsErrorWarning ? m('span.ml2.yellow', {title: 'Alarm evaluation error'}, '⚠️') : null
        ]);
      };

      return Promise.all(nextRequests).then(function () {
        return true;
      });
    })
    .then(function (shouldRedraw) {
      if (!shouldRedraw || !ctrl.isCurrentRoute(requestedPointId, requestedColumnRid)) {
        return;
      }
      ctrl.loading(false);
      m.redraw();
    });
  } // initPoint

  ctrl.onremove = function () {
    modal.off('closed', ctrl.initPoint);
  }

  ctrl.getOriginColumn = function (columnRid) {
    var normalizedColumnRid = String(columnRid || '');
    var url = '/api/v1/column/' + (normalizedColumnRid.charAt(0) === '#'
      ? normalizedColumnRid.slice(1)
      : normalizedColumnRid);
    return loaders.requestWithLoader({
      loader: 'main',
      url: url,
      method: 'GET',
      background: true
    })
    .then(function (result) { 
      return result;
    });
  }

  ctrl.getResource = function (pointId) {
    return loaders.requestWithLoader({
      url: '/api/v1/point/' + pointId + '/resource',
      method: 'GET',
      background: true
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
  }
 
  ctrl.getEnumerations = function () {
    return loaders.requestWithLoader({
      url: '/api/v1/enumeration/',
      method: 'GET',
      background: true
    })
    .then(function (data) {
      ctrl.enumerations(data)
    });
  }

  ctrl.getAlarmProfile = function (pointRecord) {
    return loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/alarmprofile/' + pointRecord.alarmProfile.slice(1),
      method: 'GET',
      background: true
    });
  };

  ctrl.getUsersfromGruops = (pointId, columnRid)=>{
    return loaders.requestWithLoader({
      url: '/api/v1/groups/users',
      method: 'GET',
      params: {
        groups: Point.form.receivers(),
      },
    })
    .then(function (users)  {
      if (!ctrl.isCurrentRoute(pointId, columnRid)) {
        return;
      }
      users.forEach(user=>{
        if (!ctrl.userIsAdminGroup() && user['@rid'] === auth.user()['@rid'] && user.isGroupAdmin) {
          ctrl.userIsAdminGroup(true)
        }
      });
    });  
  }
  

  return ctrl.initPoint();
};

var onbeforeupdate = function () {
  var ctrl = this;
  var nextPointId = m.route.param('pointId');
  var nextColumnRid = currentColumnRid();

  if (!nextPointId || (ctrl.pointId === nextPointId && ctrl.columnRid === nextColumnRid)) {
    return true;
  }

  ctrl.pointId = nextPointId;
  ctrl.columnRid = nextColumnRid;
  ctrl.resetPointState();
  ctrl.initPoint();
  return true;
};

var onremove = function () {
  modal.off('closed', this.initPoint);
};

var view = function () {
  var ctrl = this;
  if (!ctrl.point().name) {
   return m('div')
  }

  return m('div.container', [
    heading(),
    m(tabs, {
      tabs:{
        Graph: [pointChart, {
          pointRecord:ctrl.point(), 
          column: ctrl.originColumn(), 
          uri:'Graph', 
          alarmProfile: ctrl.alarmProfile(), 
          oncreate: (vnode)=>{
            ctrl.getChart = vnode.state.getChart
          },
          onupdate: (vnode) => {
            if (ctrl.redraw()) {
              vnode.state.getChart({alarmProfile: ctrl.alarmProfile()})
            }
          }
        }],
        Incidents: [pointEvents, {pointRecord:ctrl.point() ,column: ctrl.originColumn(), uri:'Incidents'}],
        Commands: [pointCommands, {pointRid: ctrl.point()['@rid'], pageSize: 10, pointUnit: ctrl.point().unit}],
        Documents: [pointDocuments, {pointRecord:ctrl.point() ,column: ctrl.originColumn(), uri:'Documents'}]
      }, 
      options:{
        horizontal: true, 
        default:ctrl.defaultTab, 
        link:true, 
        point:ctrl.point(), 
        column:ctrl.originColumn()
      },
      route: 'pointhistorytab'
    }),
    
    m('div', { class: 'alerts' }, m(alerts)),
    (function () {
      if (canViewFullPointConfiguration()) {
        return layout(header.vm.activeTab());
      } else if (canViewCalibrationConfiguration()) {
        return calibrationLayout();
      } else {
        return m('div');
      }
    })()
  ]);

  function canViewFullPointConfiguration () {
    var user = auth.user();
    return roleFlagIsEnabled(user && user.isSuperuser) || ctrl.userIsAdminGroup();
  }

  function canViewCalibrationConfiguration () {
    var user = auth.user();
    var resourceRecord = ctrl.resource() || {};
    return roleFlagIsEnabled(user && user.isCalibrationSuperuser) && resourceRecord['@class'] !== 'Aggregate';
  }

  function calibrationLayout () {
    return [
      m(headingElement, {label: "Point Configuration", class: 'f1 pb2 mb3 mt4'}),
      m('div.cf', [
        m(tabs, {
          tabs:{
            Calibration: [calibrationForm, {parentCtrl:ctrl}]
          },
          route: 'pointconfigtab',
          labelRenderer: ctrl.tabLabelRenderer
        })
      ])
    ]
  }

  function layout (content) {
    var resourceRecord = ctrl.resource() || {};
    if (resourceRecord['@class']==='Aggregate') {
      return [
        m(headingElement, {label: "Point Configuration", class: 'f1 mb3 mt4'}),
        m('div.cf', [
            m(tabs, {
              tabs:{
                Status: [statusForm, {parentCtrl:ctrl}],
                Configuration: [configForm, {parentCtrl:ctrl}], 
              Alarms: [alarmForm, {parentCtrl:ctrl}],
              Sampling: [samplingForm, {parentCtrl:ctrl}],
              BACnet: [bacnetForm, {parentCtrl:ctrl}],
              Overrides: [overrideForm, {parentCtrl:ctrl}]
            },
            route: 'pointconfigtab',
            labelRenderer: ctrl.tabLabelRenderer
          })
        ])
      ]
    } else {
      return [ 
        m(headingElement, {label: "Point Configuration", class: 'f1 pb2 mb3 mt4'}),
        m('div.cf', [
          m(tabs, {
            tabs:{
              Status: [statusForm, {parentCtrl:ctrl}],
              Configuration: [configForm, {parentCtrl:ctrl}],
              Alarms: [alarmForm, {parentCtrl:ctrl}],
              Sampling: [samplingForm, {parentCtrl:ctrl}],
              BACnet: [bacnetForm, {parentCtrl:ctrl}],
              Overrides: [overrideForm, {parentCtrl:ctrl}],
              Calibration: [calibrationForm, {parentCtrl:ctrl}],
              Connections: [connectionsForm, {parentCtrl:ctrl}]
            },
            route: 'pointconfigtab',
            labelRenderer: ctrl.tabLabelRenderer
          })
        ])
      ]
    }
  }

  function heading () {
    var resourceRecord = ctrl.resource() || {};
    var resourcePath = Array.isArray(resourceRecord.path) ? resourceRecord.path : [];
    var resourceName = resourceRecord.name || ctrl.point().name || 'Point';

    if (ctrl.originColumn().path && Array.isArray(ctrl.originColumn().path) && ctrl.originColumn().path.length > 0) {
      return m('div.mb3.pb1.bb.bw1.b--mid-gray.near-white.f-subheadline.flex.flex-wrap',
        pointHeaderPath.items(ctrl.originColumn()));
    } else if (resourcePath.length > 1) {
      var ancestors = resourcePath.slice(0, resourcePath.length - 1);
      var networkOverviewUrl = ancestors[0] && ancestors[0]['@id'] ? '/' + ancestors[0]['@id'].split('/').slice(3, 4).join('/').toLowerCase() : '/';
      var networkOverviewName = ancestors[0] && ancestors[0]['@class'] ? ancestors[0]['@class'].replace(/([A-Z])/g, ' $1') : resourceName;
      var showNetworkOverview = !ancestors[0] || ['BacnetServer', 'ModbusTcp', 'RestHttp', 'LontalkCnip'].indexOf(ancestors[0]['@class']) === -1;
      if (auth.user().isSuperuser && auth.user().isSuperuser == 1) {
        return m("div", {class:"container"}, [
          m('div.mb3.bb.bw1.b--mid-gray.near-white.f-subheadline.pb1.flex.flex-wrap', [
            showNetworkOverview ? m('div.mr2.nowrap.truncate', [
              m(m.route.Link, {href: networkOverviewUrl}, networkOverviewName),
              ' / '
            ]) : null,
            ancestors.map(function (ancestor, idx) {
              return m('div.mr2.nowrap.truncate', [
                m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
                ' / '
              ])
            }),
            m('div.mr2.nowrap.truncate', resourceName + ' / '),
            m('div.mr2.nowrap.truncate', ctrl.point().name)
          ]),
        ])  
      } else {
        return m("div", {class:"container"}, [
          m('div.mb3.bb.bw1.b--mid-gray.near-white.f-subheadline.pb1.flex.flex-wrap', [
            showNetworkOverview ? m('div.mr2.nowrap.truncate', [
              m('a.white', networkOverviewName),
              ' / '
            ]) : null,
            ancestors.map(function (ancestor, idx) {
              return m('div.mr2.nowrap.truncate', [
                m('a.white', ancestor.name),
                ' / '
              ])
            }),
            m('div.mr2.nowrap.truncate', resourceName + ' / '),
            m('div.mr2.nowrap.truncate', ctrl.point().name)
          ]),
        ])  
      }
      
    } else {
      return m('div.mb3.pb1.bb.bw1.b--mid-gray.near-white.f-subheadline', resourceName)
    }
  }
};

module.exports = {oninit: oninit, onbeforeupdate: onbeforeupdate, onremove: onremove, view: view};
